/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { SafePureComponent } from '../../../../../../utils/SafePureComponent';
import * as styles from './index.styles';

export class DropdownButton extends SafePureComponent {
  safeRender() {
    const { props } = this;
    const { buttonLabel, innerRef } = props;

    return (
      <button
        onClick={props.toggleModal}
        css={[styles.openButton, props.customCss]}
        ref={innerRef}
      >
        <span css={styles.solutionHeadline}>{buttonLabel}</span>
        <i css={styles.chevronIcon} className="icon-chevron" />
      </button>
    );
  }
}

DropdownButton.displayName = 'DropdownButton';

DropdownButton.defaultProps = {
  buttonLabel: '',
  toggleModal: () => {},
};

DropdownButton.propTypes = {
  buttonLabel: PropTypes.string,
  toggleModal: PropTypes.func,
};

export default DropdownButton;
